import Duration from 'components/interaction/Duration/index.jsx';
import SelectLocationType from '../SelectLocationType/index.jsx';
import messages from './messages.js';

const schema = {
  id: 'account',
  properties: [
    {
      id: 'title',
      type: 'text',
      label: messages.title,
      required: true,
    },
    {
      id: 'description',
      type: 'textarea',
      attributes: { rows: 3 },
      label: messages.description,
    },
    {
      id: 'duration',
      as: Duration,
      label: messages.duration,
      attributes: { min: 1 },
      required: true,
      type: 'number',
    },
    {
      id: 'inBetween',
      as: Duration,
      label: messages.inBetween,
      attributes: { min: 0 },
      type: 'number',
      required: true,
    },
    {
      id: 'meetingLocationType',
      label: messages.meetingLocationType,
      as: SelectLocationType,
      required: true,
    },
  ],
};

export default schema;
